import { memo } from "react";

const NameBox = memo(function NameBox(props) {
  return null; // Location name now shown in top bar
});

export default NameBox;
